class CollectionProductGrid extends HTMLElement {
  constructor() {
    super();

    // Get 'this' data
    this.products = this.querySelectorAll('[data-collection-product]');
    this.mainCollectionProductGrid = this.querySelector('#main-collection-product-grid');

    // Get 'banner' data
    this.collectionColumnBanners = document.querySelector('[data-collection-column-banners]');
    this.sectionId = this.collectionColumnBanners?.dataset.sectionId;
    this.collectionColumnBanner = document.querySelectorAll('[data-collection-column-banner');

    this.fetchSection();
  }

  fetchSection() {
    // Fetch from url
    fetch(`?section_id=${this.sectionId}`)
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');

        this.collectionColumnBanner.forEach(columnBanner => {
          this.bannerPositions = columnBanner.dataset.columnBannerPosition.replace(/\s/g, '');
          this.bannerPositionsArr = this.bannerPositions.toString().split(',');

          this.bannerPositionsArr.forEach(bannerPosition => {
            const position = bannerPosition - 1;
            this.products[position].before(columnBanner.cloneNode(true));
          });
        });

        // remove the data-fancybox-sizeguide attribute from the Collection column banners section, to prevent Fancybox showing the same popup twice
        const sizeChartsFromSection = this.collectionColumnBanners.querySelectorAll('[data-fancybox-sizeguide]');
        sizeChartsFromSection.forEach(trigger => {
          trigger.removeAttribute('data-fancybox-sizeguide');
        });

        this.initFancybox();
      })
      .catch(e => {
        console.error(e);
      });
  }

  initFancybox() {
    // Only display on click one pop-up type per Collection page, within the Promo blocks to prevent carousels of the same sizechart
    const sizechartsFancyboxAttributes = ['[data-fancybox-sizeguide="earrings"]', '[data-fancybox-sizeguide="rings"]'];

    // same Fancybox settings from the Product page for the sizechart
    sizechartsFancyboxAttributes.forEach(attribute => {
      Fancybox.bind(attribute, {
        mainClass: 'sizechart-wrapper',
        closeButton: false,
        on: {
          done: (fancybox, slide) => {
            const closeButton = slide.$content.querySelector('[data-fancybox-close]');
            closeButton.addEventListener('click', () => {
              fancybox.close();
            })
          }
        }
      });
    });
  }
}

if (!customElements.get('collection-product-grid')) {
  customElements.define('collection-product-grid', CollectionProductGrid);
}